import moment from "moment";

export const getFormatedDate = (date: string) =>
  moment(date).format("DD. MM. YYYY. HH:mm:ss");

export const getFormatedDateForSearch = (date: string) =>
  moment(date).format("DD.MM.YYYY.HH:mm:ss");

const remoteLabel = "remote:";

export const getFullName = (
  firstName: string,
  lastName: string,
  email: string
) => {
  if (!firstName || !lastName) {
    if (email && email.includes(remoteLabel)) {
      return email?.replace(remoteLabel, "");
    }
    return email;
  }

  return `${firstName} ${lastName}`;
};

export const getLastModifiedMessage = (
  firstName: string = "",
  lastName: string = "",
  email: string = "",
  date: string = ""
) => `${getFullName(firstName, lastName, email)}, ${getFormatedDate(date)}`;

export const trimString = (value: string) => value.replace(/  +/g, " ").trim();

export const getFirstLetterToUpperCase = (label: string) =>
  label.charAt(0).toUpperCase() + label.slice(1);

export const defaultRowsPerPage = 25;
export const rowsPerPageOptions = [10, 25, 50, 100];

export default {
  getFormatedDate,
  getLastModifiedMessage,
  trimString,
  getFirstLetterToUpperCase,
};
